import { getUserFromLocalstorage } from './localStorage';

/**
 * The logged-in user's business type, as the API returned it. Interpreters carry their
 * own list, customers inherit theirs from their usergroup.
 * @returns {object|null} The business type, or null when there is no user or no business type.
 */
export const getBusinessType = () => {
  const user = getUserFromLocalstorage();

  if (user.businessTypes && user.businessTypes.length > 0) {
    return user.businessTypes[0];
  }
  if (user?.userGroup?.businessType) {
    return user.userGroup.businessType;
  }
  return null;
};

/**
 * The logged-in user's business type tag, e.g. 'herotolk-norway'.
 * @returns {string|null} The tag, or null when there is no user or no business type.
 */
export const getBusinessTypeTag = () => getBusinessType()?.tag ?? null;

export default getBusinessTypeTag;
